var map = {
	"./emoji-agenda.svg": 1014,
	"./emoji-box.svg": 1015,
	"./emoji-camera.svg": 1016,
	"./emoji-capsule.svg": 1017,
	"./emoji-chat.svg": 1018,
	"./emoji-done.svg": 1019,
	"./emoji-facebook.svg": 1020,
	"./emoji-france.svg": 1021,
	"./emoji-grec.svg": 1022,
	"./emoji-instagram.svg": 1023,
	"./emoji-lampe.svg": 1024,
	"./emoji-laptop.svg": 1025,
	"./emoji-linkedin.svg": 1026,
	"./emoji-maroc.svg": 1027,
	"./emoji-messagerie.svg": 1028,
	"./emoji-money.svg": 1029,
	"./emoji-money2.svg": 1030,
	"./emoji-pen.svg": 1031,
	"./emoji-point.svg": 1032,
	"./emoji-smile.svg": 1033,
	"./emoji-smileSick.svg": 1034,
	"./emoji-stats.svg": 1035,
	"./emoji-tick.svg": 1036,
	"./emoji-write.svg": 1037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1013;